(function () {
  'use strict';

  var panelState = null;
  var selectedCountry = null;
  var FALLBACK_COUNTRIES = [
    { c: 'BR', n: 'Brazil', p: '+55' },
    { c: 'PT', n: 'Portugal', p: '+351' },
    { c: 'US', n: 'United States', p: '+1' },
    { c: 'IT', n: 'Italy', p: '+39' },
    { c: 'ES', n: 'Spain', p: '+34' },
    { c: 'FR', n: 'France', p: '+33' },
    { c: 'DE', n: 'Germany', p: '+49' },
    { c: 'IL', n: 'Israel', p: '+972' }
  ];

  function byId(id) { return document.getElementById(id); }
  function digits(v) { return String(v || '').replace(/\D/g, ''); }
  function countries() {
    return Array.isArray(window.PMY_COUNTRIES) && window.PMY_COUNTRIES.length ? window.PMY_COUNTRIES : FALLBACK_COUNTRIES;
  }
  function checkout() { return byId('sticky-checkout-form'); }

  function flagHtml(code) {
    var cc = String(code || 'BR').toLowerCase();
    return '<img src="https://flagcdn.com/20x15/' + cc + '.png" srcset="https://flagcdn.com/40x30/' + cc + '.png 2x" width="20" height="15" alt="' + cc.toUpperCase() + '" style="border-radius:2px;object-fit:cover;flex-shrink:0;display:block;">';
  }

  function defaultCountryCode() {
    var lang = String(document.documentElement.lang || 'en').toLowerCase();
    if (lang === 'pt-pt') return 'PT';
    if (lang.indexOf('pt') === 0) return 'BR';
    if (lang.indexOf('it') === 0) return 'IT';
    if (lang.indexOf('es') === 0) return 'ES';
    if (lang.indexOf('fr') === 0) return 'FR';
    if (lang.indexOf('de') === 0) return 'DE';
    if (lang.indexOf('he') === 0) return 'IL';
    return 'US';
  }

  function findCountry(code) {
    var list = countries();
    return list.find(function (x) { return x.c === code; }) || list.find(function (x) { return x.c === 'BR'; }) || FALLBACK_COUNTRIES[0];
  }

  function injectStyles() {
    if (byId('pmy-checkout-ui-v2-styles')) return;
    var s = document.createElement('style');
    s.id = 'pmy-checkout-ui-v2-styles';
    s.textContent = `
      #sticky-checkout-form .pmy-native-hidden {
        position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;
        pointer-events:none!important;margin:0!important;padding:0!important;overflow:hidden!important;
      }
      #sticky-checkout-form .pmy-select-shell{position:relative;width:100%;min-width:0;}
      #sticky-checkout-form .pmy-select-trigger,
      #sticky-checkout-form .pmy-date-trigger{
        width:100%;min-height:42px;display:flex;align-items:center;justify-content:space-between;gap:10px;
        padding:9px 14px;border:1px solid rgba(0,0,0,.15);border-radius:12px;background:rgba(255,255,255,.76);
        color:#1a1a1a;font:inherit;font-size:.9rem;text-align:left;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,.025);
        transition:border-color .18s ease,box-shadow .18s ease,background .18s ease;
      }
      #sticky-checkout-form .pmy-select-trigger:hover,
      #sticky-checkout-form .pmy-select-trigger[aria-expanded="true"],
      #sticky-checkout-form .pmy-date-trigger:hover,
      #sticky-checkout-form .pmy-date-trigger.is-open,
      #sticky-checkout-form .phone-prefix-trigger[aria-expanded="true"]{
        background:#fff!important;border-color:var(--btn-bg,#125a2b)!important;box-shadow:0 0 0 3px rgba(18,90,43,.08)!important;
      }
      #sticky-checkout-form .pmy-select-label{min-width:0;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
      #sticky-checkout-form .pmy-select-trigger::after{
        content:'';width:7px;height:7px;flex:0 0 7px;border-right:1.8px solid currentColor;border-bottom:1.8px solid currentColor;
        transform:rotate(45deg) translateY(-2px);transition:transform .18s ease;opacity:.62;
      }
      #sticky-checkout-form .pmy-select-trigger[aria-expanded="true"]::after{transform:rotate(225deg) translate(-1px,-1px);}
      #sticky-checkout-form .pmy-select-trigger.is-placeholder{color:rgba(0,0,0,.50);}
      #sticky-checkout-form #tour-dropdown + .pmy-select-shell .pmy-select-trigger{
        font-family:var(--font-chk-title);font-weight:var(--weight-chk-title);color:var(--c-chk-title);min-height:39px;
      }
      #sticky-checkout-form .traveler-time-select + .pmy-select-shell{display:block;width:min(100%,300px);max-width:100%;margin-top:6px;}
      #sticky-checkout-form .traveler-time-select + .pmy-select-shell .pmy-select-trigger{
        width:100%;min-height:34px;padding:6px 11px;border-radius:10px;background:#fff;color:#4b4b4b;font-size:.78rem;
      }
      #sticky-checkout-form select.is-invalid + .pmy-select-shell .pmy-select-trigger{
        border-color:#d9534f!important;box-shadow:0 0 0 3px rgba(217,83,79,.08)!important;
      }
      .pmy-select-panel{
        position:fixed;z-index:2147483646;max-width:calc(100vw - 24px);max-height:min(320px,calc(100vh - 24px));overflow:auto;
        padding:7px 0;background:var(--search-drop-bg,#fff);color:var(--search-drop-text,#1a1a1a);
        border:1px solid var(--search-border,#dedede);border-radius:14px;box-shadow:0 14px 38px rgba(0,0,0,.17);
        opacity:0;visibility:hidden;transform:translateY(-6px) scale(.99);transition:opacity .14s ease,transform .14s ease,visibility .14s;
        text-align:left;overscroll-behavior:contain;
      }
      .pmy-select-panel.open{opacity:1;visibility:visible;transform:translateY(0) scale(1);}
      .pmy-select-option{display:flex;align-items:center;width:100%;gap:9px;padding:10px 14px;border:0;background:transparent;color:inherit;
        font:inherit;font-size:13.5px;font-weight:500;text-align:left;cursor:pointer;transition:background .14s ease,color .14s ease;}
      .pmy-select-option:hover{background:rgba(128,128,128,.09);}
      .pmy-select-option.active{background:rgba(18,90,43,.10);color:var(--btn-bg,#125a2b);font-weight:800;}
      .pmy-select-group{padding:9px 14px 5px;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.07em;color:var(--c-optgroup-label,#c99a3c);}
      .pmy-select-empty{padding:12px 14px;color:#888;font-size:13px;}
      .pmy-country-panel{width:min(330px,calc(100vw - 24px));overflow:hidden;padding:0;}
      .pmy-country-search{position:sticky;top:0;z-index:2;padding:10px;background:#fff;border-bottom:1px solid rgba(0,0,0,.08);}
      .pmy-country-search input{width:100%;border:1px solid #dedede;border-radius:11px;padding:9px 11px;font:inherit;font-size:13px;outline:none;background:#fafafa;color:#1a1a1a;}
      .pmy-country-search input:focus{border-color:var(--btn-bg,#125a2b);box-shadow:0 0 0 3px rgba(18,90,43,.08);background:#fff;}
      .pmy-country-list{max-height:250px;overflow:auto;padding:5px 0;}
      .pmy-country-code{font-size:11px;font-weight:800;opacity:.72;min-width:23px;}
      .pmy-country-name{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
      .pmy-country-prefix{margin-left:auto;font-size:12px;font-weight:700;opacity:.68;}
      #sticky-checkout-form .phone-prefix-trigger{min-height:42px!important;border-radius:12px!important;}
      #sticky-checkout-form .prefix-dropdown{display:none!important;}
      #sticky-checkout-form #chk-date.pmy-native-hidden{display:block!important;}
      #sticky-checkout-form .pmy-date-trigger .pmy-date-value{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
      #sticky-checkout-form .pmy-date-trigger svg{width:16px;height:16px;opacity:.7;flex:0 0 16px;}
      .pmy-checkout-calendar.flatpickr-calendar{
        z-index:2147483646!important;border:1px solid var(--search-border,#dedede)!important;border-radius:14px!important;
        box-shadow:0 14px 38px rgba(0,0,0,.17)!important;padding:10px!important;font-family:inherit!important;background:#fff!important;
      }
      .pmy-checkout-calendar .flatpickr-day.selected,
      .pmy-checkout-calendar .flatpickr-day.startRange,
      .pmy-checkout-calendar .flatpickr-day.endRange{background:var(--btn-bg,#125a2b)!important;border-color:var(--btn-bg,#125a2b)!important;color:#fff!important;font-weight:800!important;}
      .pmy-checkout-calendar .flatpickr-day:hover{background:rgba(18,90,43,.08)!important;border-color:transparent!important;}
      html[data-bs-theme="dark"] .pmy-select-panel,
      html[data-bs-theme="dark"] .pmy-country-search,
      html[data-bs-theme="dark"] .pmy-country-search input,
      html[data-bs-theme="dark"] .pmy-checkout-calendar.flatpickr-calendar{background:#fff!important;color:#1a1a1a!important;}
      @media(max-width:520px){
        .pmy-select-panel{max-width:calc(100vw - 16px);}
        .pmy-country-panel{width:calc(100vw - 24px);}
      }
    `;
    document.head.appendChild(s);
  }

  function closePanel() {
    if (!panelState) return;
    if (panelState.panel) panelState.panel.classList.remove('open');
    if (panelState.trigger) panelState.trigger.setAttribute('aria-expanded', 'false');
    panelState = null;
  }

  function newPanel(extraClass) {
    var p = document.createElement('div');
    p.className = 'pmy-select-panel' + (extraClass ? ' ' + extraClass : '');
    document.body.appendChild(p);
    return p;
  }

  function positionPanel(panel, trigger, preferredWidth) {
    var r = trigger.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var width = Math.min(Math.max(preferredWidth || r.width, r.width), vw - 24);
    panel.style.width = width + 'px';
    panel.style.left = Math.max(12, Math.min(r.left, vw - width - 12)) + 'px';
    panel.style.top = (r.bottom + 7) + 'px';
    panel.style.bottom = 'auto';
    panel.style.transformOrigin = 'top left';
    panel.classList.add('open');
    var pr = panel.getBoundingClientRect();
    if (pr.bottom > vh - 12 && r.top > pr.height + 20) {
      panel.style.top = Math.max(12, r.top - pr.height - 7) + 'px';
      panel.style.transformOrigin = 'bottom left';
    }
  }

  function enhanceSelect(select) {
    if (!select || select.dataset.pmyUiV2 === '1') return;
    select.dataset.pmyUiV2 = '1';
    select.classList.add('pmy-native-hidden');

    var shell = document.createElement('div');
    shell.className = 'pmy-select-shell';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'pmy-select-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    var label = document.createElement('span');
    label.className = 'pmy-select-label';
    trigger.appendChild(label);
    shell.appendChild(trigger);
    select.insertAdjacentElement('afterend', shell);

    var panel = newPanel('');
    panel.setAttribute('role', 'listbox');

    function sync() {
      var opt = select.options[select.selectedIndex];
      var text = opt ? opt.textContent.trim() : '';
      label.textContent = text;
      trigger.classList.toggle('is-placeholder', !select.value);
      trigger.title = text;
    }

    function addOption(opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pmy-select-option' + (opt.value === select.value ? ' active' : '');
      b.setAttribute('role', 'option');
      b.setAttribute('aria-selected', opt.value === select.value ? 'true' : 'false');
      b.textContent = opt.textContent.trim();
      b.disabled = !!opt.disabled;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        select.value = opt.value;
        sync();
        closePanel();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      panel.appendChild(b);
    }

    function rebuild() {
      panel.innerHTML = '';
      var count = 0;
      Array.prototype.forEach.call(select.children, function (node) {
        if (node.tagName === 'OPTGROUP') {
          var g = document.createElement('div');
          g.className = 'pmy-select-group';
          g.textContent = node.label;
          panel.appendChild(g);
          Array.prototype.forEach.call(node.children, function (opt) { addOption(opt); count++; });
        } else if (node.tagName === 'OPTION') {
          addOption(node); count++;
        }
      });
      if (!count) {
        var empty = document.createElement('div');
        empty.className = 'pmy-select-empty';
        empty.textContent = 'No options available';
        panel.appendChild(empty);
      }
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var same = panelState && panelState.panel === panel;
      closePanel();
      if (same) return;
      rebuild();
      trigger.setAttribute('aria-expanded', 'true');
      var width = 220;
      if (select.id === 'tour-dropdown') width = 340;
      if (select.classList.contains('traveler-time-select')) width = 330;
      positionPanel(panel, trigger, width);
      panelState = { panel: panel, trigger: trigger };
    });

    select.addEventListener('change', sync);
    new MutationObserver(function () { sync(); }).observe(select, { childList: true, subtree: true });
    sync();
  }

  function enhanceAll(root) {
    root = root || document;
    var tour = byId('tour-dropdown');
    var lang = byId('checkout-lang-select');
    if (tour) enhanceSelect(tour);
    if (lang) enhanceSelect(lang);
    root.querySelectorAll('.traveler-time-select').forEach(enhanceSelect);
  }

  function formatDateValue(value) {
    var m = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? (m[3] + '/' + m[2] + '/' + m[1]) : 'dd/mm/yyyy';
  }

  function initDate() {
    var input = byId('chk-date');
    if (!input || input.dataset.pmyUiV2 === '1') return;
    if (typeof window.flatpickr !== 'function') {
      setTimeout(initDate, 100);
      return;
    }
    input.dataset.pmyUiV2 = '1';
    input.type = 'text';
    input.readOnly = true;
    input.classList.add('pmy-native-hidden');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'pmy-date-trigger';
    trigger.innerHTML = '<span class="pmy-date-value">' + formatDateValue(input.value) + '</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>';
    input.insertAdjacentElement('afterend', trigger);
    var valueLabel = trigger.querySelector('.pmy-date-value');

    function syncLabel() { valueLabel.textContent = formatDateValue(input.value); }

    var fp = window.flatpickr(input, {
      minDate: 'today',
      dateFormat: 'Y-m-d',
      disableMobile: true,
      clickOpens: false,
      allowInput: false,
      appendTo: document.body,
      positionElement: trigger,
      position: 'auto left',
      onReady: function (_, __, inst) {
        inst.calendarContainer.classList.add('pmy-checkout-calendar');
      },
      onOpen: function () {
        closePanel();
        trigger.classList.add('is-open');
      },
      onClose: function () { trigger.classList.remove('is-open'); },
      onChange: function (_, dateStr) {
        input.value = dateStr || '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(syncLabel, 0);
      }
    });

    trigger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      closePanel();
      fp.open();
    });
    input.addEventListener('change', function () { setTimeout(syncLabel, 0); });
  }

  function normalizePhone() {
    var phone = byId('chk-phone-number');
    var full = byId('chk-phone-full');
    if (!phone || !full) return;
    if (!selectedCountry) selectedCountry = findCountry(defaultCountryCode());
    var raw = String(phone.value || '').trim();
    if (!raw) { full.value = ''; return; }
    if (raw.charAt(0) === '+') full.value = '+' + digits(raw);
    else if (raw.indexOf('00') === 0) full.value = '+' + digits(raw).replace(/^00/, '');
    else full.value = '+' + digits(selectedCountry.p) + digits(raw);
  }

  function setCountry(c) {
    selectedCountry = c;
    var flag = byId('prefix-flag');
    var code = byId('prefix-code');
    if (flag) flag.innerHTML = flagHtml(c.c);
    if (code) code.textContent = c.p;
    normalizePhone();
  }

  function initCountry() {
    var trigger = byId('phone-prefix-trigger');
    var phone = byId('chk-phone-number');
    if (!trigger || trigger.dataset.pmyUiV2 === '1') return;
    trigger.dataset.pmyUiV2 = '1';
    trigger.removeAttribute('onclick');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    selectedCountry = findCountry(defaultCountryCode());
    setCountry(selectedCountry);

    var panel = newPanel('pmy-country-panel');

    function build(q) {
      panel.innerHTML = '';
      var searchWrap = document.createElement('div');
      searchWrap.className = 'pmy-country-search';
      var search = document.createElement('input');
      search.type = 'search';
      search.autocomplete = 'off';
      search.placeholder = 'Search country, code or DDI...';
      search.value = q || '';
      searchWrap.appendChild(search);
      panel.appendChild(searchWrap);
      var list = document.createElement('div');
      list.className = 'pmy-country-list';
      panel.appendChild(list);

      function render(value) {
        var text = String(value || '').toLowerCase().trim();
        var d = digits(text);
        list.innerHTML = '';
        var items = countries().filter(function (c) {
          return !text || c.c.toLowerCase().indexOf(text) !== -1 || String(c.n || '').toLowerCase().indexOf(text) !== -1 || String(c.p || '').indexOf(text) !== -1 || (d && digits(c.p).indexOf(d) !== -1);
        });
        if (!items.length) {
          var empty = document.createElement('div');
          empty.className = 'pmy-select-empty';
          empty.textContent = 'No countries found';
          list.appendChild(empty);
          return;
        }
        items.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pmy-select-option' + (selectedCountry && selectedCountry.c === c.c ? ' active' : '');
          b.innerHTML = flagHtml(c.c) + '<span class="pmy-country-code">' + c.c + '</span><span class="pmy-country-name">' + c.n + '</span><span class="pmy-country-prefix">' + c.p + '</span>';
          b.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation(); setCountry(c); closePanel();
          });
          list.appendChild(b);
        });
      }

      search.addEventListener('input', function () { render(search.value); });
      search.addEventListener('click', function (e) { e.stopPropagation(); });
      render(q);
      setTimeout(function () { search.focus(); }, 25);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var same = panelState && panelState.panel === panel;
      closePanel();
      if (same) return;
      build('');
      trigger.setAttribute('aria-expanded', 'true');
      positionPanel(panel, trigger, 330);
      panelState = { panel: panel, trigger: trigger };
    });

    if (phone) {
      phone.removeAttribute('oninput');
      phone.setAttribute('inputmode', 'tel');
      phone.setAttribute('autocomplete', 'tel');
      phone.addEventListener('input', function () {
        var v = phone.value.replace(/[^0-9+()\s.\-]/g, '');
        if (v.indexOf('+') > 0) v = v.replace(/\+/g, '');
        else if (v.indexOf('+') === 0) v = '+' + v.slice(1).replace(/\+/g, '');
        phone.value = v;
        normalizePhone();
      });
    }

    window.togglePrefixDropdown = function (e) { if (e) e.preventDefault(); trigger.click(); };
    window.closePrefixDropdown = closePanel;
    window.filterPrefixes = function () {};
    window.updateFullPhone = normalizePhone;
    window.formatPhoneNumber = function (el) { if (el) el.dispatchEvent(new Event('input', { bubbles: true })); };
  }

  function init() {
    if (!checkout()) return;
    injectStyles();
    initCountry();
    enhanceAll(document);
    initDate();

    var travelers = byId('dynamic-travelers-container');
    if (travelers && travelers.dataset.pmyUiV2Observer !== '1') {
      travelers.dataset.pmyUiV2Observer = '1';
      new MutationObserver(function () { enhanceAll(travelers); }).observe(travelers, { childList: true, subtree: true });
    }
  }

  document.addEventListener('click', function (e) {
    if (panelState && panelState.panel && !panelState.panel.contains(e.target) && (!panelState.trigger || !panelState.trigger.contains(e.target))) closePanel();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  window.addEventListener('resize', closePanel, { passive: true });
  window.addEventListener('scroll', function (e) {
    if (!panelState || !panelState.panel) return;
    var target = e.target;
    if (target && (target === panelState.panel || panelState.panel.contains(target))) return;
    closePanel();
  }, { passive: true, capture: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();